import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { HorariosIda } from "./HorariosIda";
import { HorariosVolta } from "./HorariosVolta";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import Swal from "sweetalert2";

export function Horarios() {
  const [active, setActive] = useState<number>(0)

  const {reset, getValues} = useFormContext()

  const handleTableChange = (index: number) => {
    const values = getValues()
    const { search, ...updatedValues } = values;
    console.log(search)

    if(!Object.prototype.hasOwnProperty.call(values, 'selecionada')){
      Swal.fire({
        title: 'Selecione a passagem de ida',
        toast: true,
        icon: "info"
      })  
      return;
    }

    const origem = values.origem;
    const destino  = values.destino;

    setActive(index)
    reset({
      ...updatedValues,
      contexto: active === 0 ? 'ida' : 'volta',
      origem: destino,
      destino: origem,
    })

  }

  return (
    <Tabs mt={2} isFitted variant="enclosed-colored" bg={"white"} index={active} onChange={handleTableChange}>
      <TabList mb="0">
        <Tab
          _selected={{ color: "white", bg: "#333333" }}
          justifyContent={"start"}
          fontSize={"lg"}
          fontWeight={"bold"}
        >
          Escolha o horário de ida
        </Tab>
        <Tab
          _selected={{ color: "white", bg: "#333333" }}
          justifyContent={"start"}
          fontSize={"lg"}
          fontWeight={"bold"}
        >
          Escolha o horário de volta
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel p={0}>
            <HorariosIda active={active}/>
        </TabPanel>
        <TabPanel p={0}>
          <HorariosVolta active={active} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
